export enum EDrupalRoutes {
  login = "/portalLogin",
  logout = "/portalLogout",
  changePassword = "/portalChangePassword",
  forgottenPassword = "/portalForgottenPassword",
  register = "/portalRegister",
  portalNewCompetitionRequest = "/portalNewCompetitionRequest",
  // dashboard = "/portalDashboard",
  dog = "/portalDog",
  drupalPedigreeDuplicataRequest = "/portalDrupalPedigreeDuplicataRequest",
  requestList = "/portalRequestlist",
  newRequest = "/portalNewrequest",
  workbookRequest = "/portalWorkbookrequest",
  workAttestRequest = "/portalWorkAttestRequest",
  tempRshRequest = "/portalTemprshrequest",
  healthTestRequest = "/portalHealthTestRequest",
  titleRequest = "/portalTitleRequest",
  broodRequest = "/portalBroodRequest",
  rshRequest = "/portalRshRequest",
  membershipRequest = "/portalMembershipRequest",
  rishRequest = "/portalRishRequest",
  dogOwnershipChangeRequest = "/portalDogOwnershipChangeRequest",
  competitionRequest = "/portalCompetitionRequest",
  pedigreeDuplicataRequest = "/portalPedigreeDuplicataRequest",
  pedigreeRequest = "/portalPedigreeRequest",
  ImportRequst = "/portalImportRequst",
  miscellaneousRequest = "/portalMiscellaneousRequest",
  dysplasiaRequest = "/portalDysplasiaRequest",
  kennelImportRequest = "/portalKennelImportRequest",
  kennelOwnershipChangeRequest = "/portalKennelOwnershipChangeRequest",
  newKennelRequest = "/portalNewKennelRequest",
  kennelExportRequest = "/portalKennelExportRequest",
  kennelNameChangeRequest = "/portalKennelNameChangeRequest",
  breed = "/portalBreed",
  affix = "/portalAffix",
  competition = "/portalCompetition",
  judge = "/portalJudge",
  club = "/portalClub",
  babyDog = "/portalBabyDog",
  profile = "/portalProfile",
  genealogy = "/portalGenealogy",
  emailError = "/portalEmailError",
  crcb = "/crcb",
}
